module.exports = __webpack_public_path__ + "img/pdf_icon.6ef05de1.svg";